var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7497 10.6263C13.7494 11.481 13.4573 12.31 12.9216 12.976C12.3859 13.6421 11.6389 14.1052 10.8041 14.2887L10.4053 13.0925C10.7705 13.0324 11.1177 12.892 11.4221 12.6814C11.7264 12.4709 11.9803 12.1955 12.1653 11.875H10.6247C10.2932 11.875 9.97523 11.7433 9.74081 11.5089C9.50639 11.2745 9.37469 10.9565 9.37469 10.625V8.125C9.37469 7.79348 9.50639 7.47554 9.74081 7.24112C9.97523 7.0067 10.2932 6.875 10.6247 6.875H12.4609C12.3084 5.66681 11.7203 4.5558 10.8068 3.75042C9.8934 2.94505 8.71747 2.50067 7.49969 2.50067C6.28192 2.50067 5.10599 2.94505 4.19255 3.75042C3.27912 4.5558 2.69096 5.66681 2.53844 6.875H4.37469C4.70622 6.875 5.02416 7.0067 5.25858 7.24112C5.493 7.47554 5.62469 7.79348 5.62469 8.125V10.625C5.62469 10.9565 5.493 11.2745 5.25858 11.5089C5.02416 11.7433 4.70622 11.875 4.37469 11.875H2.49969C2.16817 11.875 1.85023 11.7433 1.61581 11.5089C1.38139 11.2745 1.24969 10.9565 1.24969 10.625V7.5C1.24969 4.04813 4.04782 1.25 7.49969 1.25C10.9516 1.25 13.7497 4.04813 13.7497 7.5V10.6263ZM12.4997 10.625V8.125H10.6247V10.625H12.4997ZM2.49969 8.125V10.625H4.37469V8.125H2.49969Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.713e0807658b38995f12bc493c3aafdb.svg";
export { ForwardRef as ReactComponent };